export const create = {
  form: {
    code: 'Code',
    name: 'Name',
    size: 'Size',
    submit: 'Submit',
    requireCode: 'Please input uniform code!',
    requireName: 'Please input uniform name!',
    requireSize: 'Please input uniform size!',
  },
  pageHeader: {
    title: 'New Uniform',
  },
}
